import React, { useContext, useState, useRef, useEffect } from "react";
import "./css/footer.css";
import "./css/footerMovil.css";
import { IdiomaContext } from '../components/context/IdiomaContext';
import { traducciones } from '../data/footerData';
import LogoIcon from './LogoIcon';

function Footer() {
    const [menuOpen, setMenuOpen] = useState(false);
    const [accordionOpen, setAccordionOpen] = useState(true);
    const { idioma } = useContext(IdiomaContext);
    const traduccion = traducciones[idioma];
    const accordionRef = useRef(null); // Ref para el contenedor del acordeón

    const toggleMenu = () => {
        setMenuOpen(!menuOpen);
    };
    
    const toggleAccordion = () => {
        setAccordionOpen(!accordionOpen);
    };

    // Efecto para el auto-scroll cuando el acordeón se abre/cierra
    useEffect(() => {
        // Eliminar el scroll automático
        // Si necesitas scroll al cerrar, puedes agregar lógica aquí
    }, [accordionOpen]);

    return (
        <>
            <div className="icon-menu">
                {/* Íconos laterales con animaciones */}
                <div className={`icon-group left ${menuOpen ? "open" : ""}`}>
                    <div className="icon__ok">
                        <div className="icon__p-text">{traduccion.design}</div> 
                    </div>
                    <div className="icon__address">
                        <div className="icon__p-text2">{traduccion.title2}</div>
                        <a href="https://www.qanticodevs.com/" target="_blank" rel="noopener noreferrer" className="icon__p-text2">{traduccion.developer}</a> 
                    </div>
                </div>
                <div className={`main-icon ${menuOpen ? "open" : ""}`} onClick={toggleMenu}>
                    <div className="icon__p">
                        <div className="icon__p-text">{traduccion.title} {new Date().getFullYear()}</div>
                    </div>
                </div>
                <div className={`icon-group right ${menuOpen ? "open" : ""}`}>
                    <div className="icon__location">
                        <div className="icon__p-text">{traduccion.location}</div> 
                    </div>
                    <div className="icon__address">
                        <div className="icon__p-text2">{traduccion.city}</div>
                        <div className="icon__p-text2">{traduccion.address}</div> 
                    </div>
                </div>
            </div>
            
            {/* Acordeón móvil con ref para el scroll */}
            <div className="mobile-only" ref={accordionRef}>
                <div 
                    className={`toggle-icon ${accordionOpen ? 'rotate' : ''}`} 
                    onClick={toggleAccordion}
                >
                    <LogoIcon className="toggle-icon-image" />
                    <h2 className="title-icon">{traduccion.icon}</h2>
                </div>
                
                <div className={`accordion-content ${accordionOpen ? 'open' : ''}`}>
                    <div className="accordion-div">
                      <h3 className="icon__p-text">{traduccion.location}</h3>
                      <div className="icon__location"></div>
                      <div className="icon__p-text2">{traduccion.city}</div>
                      <div className="icon__p-text2">{traduccion.address}</div>     
                    
                    </div>
                    <div className="accordion-div">
                      <h3 className="icon__p-text">{traduccion.design}</h3>
                      <div className="icon__ok"></div>
                      <div className="icon__p-text2">{traduccion.title2}</div>
                      <a href="https://www.qanticodevs.com/" target="_blank" rel="noopener noreferrer" className="icon__p-text2">{traduccion.developer}</a>
                    </div>
                </div>
                
            </div>
            <div className="accordion-fin"></div>
        </>
    );
}

export default Footer;